

export const appMailSupport = computed<string>(() => {
  (useState('appMailSupport').value == 'nocookies@learn-atc.com' && useState<boolean|null>('isConsentGiven',() => null).value !== null)
    ? ws.send<string>('app.emailsupport').then((r) => {
      useState('appMailSupport',() => 'nocookies@learn-atc.com').value = r
    })
    :  []
  return useState('appMailSupport', () => 'nocookies@learn-atc.com').value as string
})

// emailoffice
export const appMailOffice = computed<string>(() => {
  (useState('appMailOffice').value == 'nocookies@learn-atc.com' && useState<boolean|null>('isConsentGiven',() => null).value !== null)
    ? ws.send<string>('app.emailoffice').then((r) => {
      useState('appMailOffice',() => 'nocookies@learn-atc.com').value = r
    })
    :  []
  return useState('appMailOffice', () => 'nocookies@learn-atc.com').value as string
})

// emailblax
export const appMailBlax = computed<string>(() => {
  (useState('appMailBlax').value == 'nocookies@learn-atc.com' && useState<boolean|null>('isConsentGiven',() => null).value !== null)
    ? ws.send<string>('app.emailblax').then((r) => {
      useState('appMailBlax',() => 'nocookies@learn-atc.com').value = r
    })
    :  []
  return useState('appMailBlax', () => 'nocookies@learn-atc.com').value as string
})

// emailclesk
export const appMailClesk = computed<string>(() => {
  (useState('appMailClesk').value == 'nocookies@learn-atc.com' && useState<boolean|null>('isConsentGiven',() => null).value !== null)
    ? ws.send<string>('app.emailclesk').then((r) => {
      useState('appMailClesk',() => 'nocookies@learn-atc.com').value = r
    })
    :  []
  return useState('appMailClesk', () => 'nocookies@learn-atc.com').value as string
})

// emailsales
export const appMailSales = computed<string>(() => {
  (useState('appMailSales').value == 'nocookies@learn-atc.com' && useState<boolean|null>('isConsentGiven',() => null).value !== null)
    ? ws.send<string>('app.emailsales').then((r) => {
      useState('appMailSales',() => 'nocookies@learn-atc.com').value = r
    })
    :  []
  return useState('appMailSales', () => 'nocookies@learn-atc.com').value as string
})

